import { auth } from "../firebase";
import { fromUtcToDate } from "../utils/dateFormatter";
import { isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import moment from 'moment-timezone';

class StatusHistory {
    status = null;
    by = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    at = moment().utc().toDate();

    constructor(statusHistory) {
        if (isObjectNotEmpty(statusHistory)) {
            if (isStringNotEmpty(statusHistory.status)) { this.status = statusHistory.status; }
            if (isStringNotEmpty(statusHistory.by)) { this.by = statusHistory.by; }
            if (isNotNullOrUndefined(statusHistory.at)) { this.at = statusHistory.at; }
        }
    }

    toDto = () => {
        return {
            status: this.status,
            by: this.by,
            at: this.at,
        };
    }

    static addNewStatus = (newStatus = "", statusHistories = [], at = null, by = null) => {
        let newStatusHistory = new StatusHistory({ status: newStatus, at: at, by: by }).toDto();
        if (isListNotEmpty(statusHistories)) {
            let existingStatusHistories = statusHistories.map((statusHistory) => {
                return new StatusHistory({ status: statusHistory.status, by: statusHistory.by, at: fromUtcToDate(statusHistory.at, 'US/Pacific') }).toDto();
            });
            return [...existingStatusHistories, newStatusHistory];
        } else {
            return [newStatusHistory];
        }
    }
};

export default StatusHistory;